import React, { useCallback, useState } from 'react';

import { Button } from '../components';
import { Input } from '../components/basic-inputs/input';
import { useCreate } from '../hooks';

interface NewBeneficiaryPageProps {
  handleSaveCompletion?: () => void;
}

export function NewBeneficiaryPage({ handleSaveCompletion }: NewBeneficiaryPageProps) {
  const { handleCreate } = useCreate('people');

  const [ error, setError ] = useState('');

  const handleSave = useCallback(async () => {
    const payload = {} as Record<string, string>;

    payload.first_name = (document.getElementById('first-name') as HTMLInputElement).value;
    payload.middle_name = (document.getElementById('middle-name') as HTMLInputElement).value;
    payload.last_name = (document.getElementById('last-name') as HTMLInputElement).value;
    payload.contact_email = (document.getElementById('email') as HTMLInputElement).value;
    payload.contact_phone = (document.getElementById('phone-number') as HTMLInputElement).value;

    if (!payload.contact_email && !payload.contact_phone) {
      return setError('Must fill out email or phone number');
    }

    await handleCreate(payload);

    if (handleSaveCompletion) {
      handleSaveCompletion();
    }
  }, []);

  return (
    <div className="new-beneficiary-page">
      <h1>New Beneficiary</h1>
      <Input id="first-name" label="First Name" required />
      <Input id="middle-name" label="Middle Name" />
      <Input id="last-name" label="Last Name" required />
      <p>Must fill out email or phone number</p>
      <Input id="email" label="Email" />
      <Input id="phone-number" label="Phone Number" />
      <br />
      <br />
      <div className="button-container">
        <Button onClick={handleSave}>Save</Button>
      </div>
    </div>
  );
}
